import styled from 'styled-components';

import { breakpoints, Heading } from '@notino/react-styleguide';

import { TitleCSS, CommonMarginWrapper } from '../../styled';

export const Wrapper = styled(CommonMarginWrapper)`
  max-width: 1005px;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 0.5rem;
  }

  // reset layout CSS
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export const Title = styled(Heading.H2)`
  ${TitleCSS};
  font-size: 1.2rem !important;
  margin: 0.5rem 0 0;

  @media (min-width: ${breakpoints.md}) {
    font-size: 1.75rem !important;
    margin-top: 3rem;
    margin-bottom: 1.75rem;
  }
`;
